



























import { Vue, Component, Mixins } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  async handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确认要添加吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("oplatformapps/editgroup", {
              id: this.editId,
              ...fieldValues
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success("添加成功");
              this.handleCancel();
            } else {
              this.$message.error("添加失败");
            }
          }
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("oplatformapps/getgroup", {
      id: this.editId
    });

    this.spinLoading = false;

    if (res && res.Data) {
      this.formData = res.Data;
    }
  }
}
